import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useWindowListener } from '@quizzach/contexts';

import {
	AuthField,
	AuthForgotLink,
	BtnTeal,
	LoginFormEl,
} from '@quizzach/styles';
import {
	LoginState,
	loginFields,
	RoutePath,
	ApiFailedReason,
} from '@quizzach/interfaces';
import { useLogin } from '@quizzach/api-hooks';
import { AlertMessage } from '@quizzach/components';
import { FaEye, FaEyeSlash } from 'react-icons/fa6';

export const LoginForm = () => {
	const [state, setState] = useState(new LoginState());
	const [error, setError] = useState<boolean>(false);
	const [showPassword, setShowPassword] = useState<boolean>(false);
	const { errorCode, onSubmit, handleInputChange, togglePasswordVisibility } =
		useLogin();

	const { touchDevice } = useWindowListener();
	const { t } = useTranslation();

	return (
		<LoginFormEl
			onSubmit={(e) => onSubmit(e, state, setError)}
			data-id='login-form'
		>
			{loginFields.map(({ identifier, label, type, autocomplete }) => (
				<AuthField
					key={identifier}
					className='login-form-container'
					$hasEye={type === 'password'}
				>
					<input
						placeholder={t(label)}
						type={type === 'password' && showPassword ? 'text' : type}
						name={identifier}
						key={identifier}
						value={state[identifier as keyof LoginState]}
						onChange={(event) => handleInputChange(event, setState)}
						autoFocus={identifier === 'email' && !touchDevice}
						autoComplete={autocomplete}
					/>
					{type === 'password' && (
						<span
							className='eye-icon'
							onClick={() =>
								togglePasswordVisibility(showPassword, setShowPassword)
							}
						>
							{showPassword ? <FaEye /> : <FaEyeSlash />}
						</span>
					)}
				</AuthField>
			))}
			<AuthForgotLink
				to={RoutePath.ResetPassword}
				className='login-forgot-pass'
			>
				{t('auth.login.forgotPassword')}
			</AuthForgotLink>
			{error && (
				<AlertMessage
					code={
						errorCode ? ApiFailedReason.notValidAuth : ApiFailedReason.default
					}
					type='error'
					style={{ width: '100%', marginBottom: '14px' }}
				/>
			)}
			<div>
				<BtnTeal className='login-submit' type='submit'>
					{t('auth.login.submit')}
				</BtnTeal>
			</div>
		</LoginFormEl>
	);
};
